<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<campaign-search ref="search" :scrId="scrId"></campaign-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<campaign-table ref="table" @registerRtnPart="registerRtnPart" :scrId="scrId"></campaign-table>
				</sf-card>
			</div>

			<campaign-popup ref="popup" :scrId="scrId" @Refresh="Refresh"></campaign-popup>
		</div>
	</div>
</template>

<script>
import CampaignSearch from './Search/CampaignSearch.vue';
import CampaignTable from './Table/CampaignTable.vue';
import CampaignPopup from './Popup/CampaignPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		CampaignSearch,
		CampaignTable,
		CampaignPopup
	},
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		},
		registerRtnPart(param) {
			this.$refs.popup.open(param);
		}
	}
};
</script>

<style></style>
